import con from "../../../../../connection";
var path = '/authorities';
var authorities = function (url) { return function () {
    return {
        get: function () { return con.get("" + url + path, {}); },
        getDetail: function (member_id) { return con.get(url + "/" + member_id + path, {}); },
    };
}; };
export default authorities;
